module.exports = __webpack_public_path__ + "img/2020.80d54401.svg";